import { gql } from '@apollo/client';
const REMOVE_PRODUCT_COUNTRY = gql `
  mutation RemoveProductCountry($productCountryId: ID!) {
    removeProductCountry(productCountryId: $productCountryId) {
      success
    }
  }
`;
export default REMOVE_PRODUCT_COUNTRY;
